// Telemetria do modo offline (issue #781) — o par do OfflineTelemetryController.
//
// Com ligação e sessão, reporta a POST /offline_telemetry:
//   - as aberturas da página offline que app/views/pages/offline.html guardou
//     no localStorage enquanto não havia rede;
//   - o estado deste dispositivo: versão do service worker (o nome da cache
//     content-vN), se controla a página, e se a PWA está instalada.
// No máximo um relatório a cada 12 h, a não ser que haja aberturas por
// reportar. Nunca pode partir a página: qualquer falha fica para a próxima.

const VIEWS_KEY = 'elicOfflineViews';
const SENT_AT_KEY = 'elicOfflineTelemetryAt';
const DEVICE_KEY = 'elicDeviceId';
const HEARTBEAT_MS = 12 * 60 * 60 * 1000;

let inFlight = false;

function read(key) {
  try { return localStorage.getItem(key); } catch (e) { return null; }
}

function write(key, value) {
  try { localStorage.setItem(key, value); } catch (e) { /* storage cheio ou bloqueado */ }
}

function pendingViews() {
  try {
    const views = JSON.parse(read(VIEWS_KEY) || '[]');
    return Array.isArray(views) ? views : [];
  } catch (e) {
    return [];
  }
}

function deviceId() {
  let id = read(DEVICE_KEY);
  if (!id) {
    id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
      : Date.now().toString(36) + Math.random().toString(36).slice(2);
    write(DEVICE_KEY, id);
  }
  return id;
}

function serviceWorkerVersion() {
  if (!('caches' in window)) return Promise.resolve(null);
  return caches.keys()
    .then(keys => keys.find(key => /^content-v\d+$/.test(key)) || null)
    .catch(() => null);
}

export function reportOfflineTelemetry() {
  if (inFlight || !navigator.onLine) return;
  const token = document.querySelector('meta[name="csrf-token"]');
  // Só nas páginas da app com sessão (o layout com o sidebar), não no login.
  if (!token || !document.querySelector('.sidebar')) return;

  const views = pendingViews();
  const lastSent = parseInt(read(SENT_AT_KEY) || '0', 10);
  if (views.length === 0 && Date.now() - lastSent < HEARTBEAT_MS) return;

  inFlight = true;
  serviceWorkerVersion()
    .then(version => fetch('/offline_telemetry', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token.content },
      body: JSON.stringify({
        device_id: deviceId(),
        sw_version: version,
        sw_controlled: !!(navigator.serviceWorker && navigator.serviceWorker.controller),
        standalone: window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true,
        offline_views: views,
      }),
    }))
    .then((response) => {
      if (!response || !response.ok) return;
      write(SENT_AT_KEY, String(Date.now()));
      // Tira só as que foram enviadas: outra pode ter chegado entretanto.
      write(VIEWS_KEY, JSON.stringify(pendingViews().slice(views.length)));
    })
    .catch(() => { /* sem rede ou servidor em baixo: fica para a próxima */ })
    .then(() => { inFlight = false; });
}
